import { CompetitorsContent } from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/CompetitorsContent/CompetitorsContent";
import { translate } from "app/filters/i18nFilter";
import useCompetitorsQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompetitorsQuery";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";

export const CompetitorsSectionContent = () => {
    const { data, isLoading, isFetched } = useCompetitorsQuery();
    const isEmpty = (!data || data.length === 0) && isFetched;

    return (
        <Card
            isEmpty={isEmpty}
            dataAutomation="competitors-tab"
            renderContent={() => (
                <CompetitorsContent
                    competitors={data}
                    isLoading={isLoading}
                />
            )}
            header={
                <CardHeader
                    title={translate("si.company-analysis.competitors.card.header")}
                    infoTooltip={translate("si.company-analysis.competitors.card.header.info-tooltip")}
                />
            }
        />
    );
};
